import { Actions, Schemas } from "@/utils/snowplow/enums";
import {
  type GlobalEntity,
  type Impression,
  type ProductEntity,
  type PromotionEntityOld,
  type UserMetaEntity,
} from "@/utils/snowplow/types";

/**
 * Side-note that post and promotion are synonymous. However, given that we're moving to posts
 * I want to keep that nomenclature in our components consistent. So, using post here, but
 * all the types (and this payload) reference `promotion` as the name.
 */
export const createPostImpression = (action: Actions, payload: PromotionEntityOld): Impression => ({
  event: {
    schema: Schemas.PromotionEvent,
    data: {
      action,
      promotion: payload,
    },
  },
});

export const createProductImpression = (action: Actions, payload: ProductEntity): Impression => ({
  event: {
    schema: Schemas.ProductEvent,
    data: {
      action,
      product: payload,
    },
  },
});

export const createUserMetaEntity = (payload: UserMetaEntity): GlobalEntity => ({
  schema: Schemas.UserMetaEntity,
  data: payload,
});

export const createBrandImpression = (brandId: string) => ({
  event: {
    schema: Schemas.ImpressionEvent,
    context: [
      {
        schema: Schemas.BrandEntity,
        data: { id: brandId },
      },
    ],
  },
});
